import { render, staticRenderFns } from "./AvatarViewer.vue?vue&type=template&id=e26a22b8&scoped=true"
import script from "./AvatarViewer.vue?vue&type=script&lang=js"
export * from "./AvatarViewer.vue?vue&type=script&lang=js"
import style0 from "./AvatarViewer.vue?vue&type=style&index=0&id=e26a22b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e26a22b8",
  null
  
)

export default component.exports